// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"Jumbotron_jumbotron__ICs_o","jumbotron__content":"Jumbotron_jumbotron__content__tURQe","visible":"Jumbotron_visible__398oX","hidden":"Jumbotron_hidden__114lK"};